<div class="mat-form-field-wrapper">
  <mat-form-field>
    <label [for]="controlName">{{label}}<span class="required">*</span></label>
    <input
      [disabled]="disabled"
      [id]="controlName"
      [type]="type"
      matInput
      [(ngModel)]="value"
      (ngModelChange)="innerModelChanged()"
      (blur)="onTouchedCallback()"
      [matAutocomplete]="autoCompanyContactField" />
  </mat-form-field>
  <mat-autocomplete #autoCompanyContactField>
    <mat-option
      [disabled]="disabled"
      *ngFor="let customer of suggestions"
      [value]="customer.name1"
      matTooltip="{{ customer | ivCustomerAddressTooltipFn }}"
      (onSelectionChange)="customerSelectionChange($event, customer)">
      <span
        class="dropdown-tooltip {{controlName}}-{{customer.id}}">
        {{ customer | ivCustomerNameFn }}
      </span>
    </mat-option>
  </mat-autocomplete>
</div>
